<template>
    <v-container class="py-7">
        <v-row>
            <v-col cols="12">
                <div class="title-container">
                    <div class="title-block">
                        <span class="page-title">Assembleias</span>
                        <v-breadcrumbs class="app-breadcrumb" divider="›" :items="breadcrumbItems"></v-breadcrumbs>
                    </div>
                    <div class="button-group">
                        <v-btn color="primary" elevation="0" to="/agcs/novo">Incluir</v-btn>
                    </div>
                </div>
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="12">
                <v-card class="filter-card">
                    <v-card-title class="filter-card-title">Filtro</v-card-title>
                    <v-card-text>
                        <v-form @submit.prevent="search">
                            <v-row>
                                <v-col cols="12" md="3">
                                    <v-text-field dense outlined label="Nome" v-model="filter.name" hide-details clearable />
                                </v-col>
                                <v-col cols="12" md="3">
                                    <v-autocomplete dense outlined label="Caso" :items="clients" item-text="name" item-value="id"
                                        v-model="filter.client_id" hide-details clearable no-data-text="Nenhum caso encontrado" />
                                </v-col>
                                <v-col cols="12" md="2">
                                    <v-select dense outlined label="Período" :items="periods" v-model="filter.period" hide-details />
                                </v-col>
                                <v-col cols="12" md="2">
                                    <v-select dense outlined label="Situação" :items="statusOptions" item-text="name" item-value="id"
                                        v-model="filter.status" hide-details clearable />
                                </v-col>
                                <v-col cols="12" md="2" class="d-flex align-center">
                                    <v-btn type="submit" color="primary" elevation="0" block>Filtrar</v-btn>
                                </v-col>
                            </v-row>
                        </v-form>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="12">
                <v-card class="table-card">
                    <v-card-title class="table-card-title">Assembleias</v-card-title>
                    <v-card-text>
                        <v-data-table :headers="headers" :items="items" :server-items-length="count" :disable-sort="true"
                            :loading="loading" :options.sync="options" :footer-props="footerOptions"
                            no-data-text="Nenhuma assembleia encontrada" loading-text="Carregando dados..."
                            class="app-table hover-table" @click:row="viewItem">

                            <template v-slot:[`item.date`]="{ item }">
                                <div class="agc-date">
                                    <strong>{{ item.date | defaultDate('DD/MM/YYYY') }}</strong>
                                    <span>{{ item.date | defaultDate('HH:mm') }}</span>
                                </div>
                            </template>

                            <template v-slot:[`item.client.name`]="{ item }">
                                {{ item.client ? item.client.name : '—' }}
                            </template>

                            <template v-slot:[`item.status`]="{ item }">
                                <v-chip small label text-color="white" :color="statusColor(item.status)">
                                    {{ statusName(item.status) }}
                                </v-chip>
                            </template>

                            <template v-slot:[`item.actions`]="{ item }">
                                <div class="text-no-wrap">
                                    <v-tooltip bottom>
                                        <template #activator="{ on }">
                                            <v-icon v-on="on" size="20" class="mr-2" @click.stop="viewItem(item)">mdi-eye-outline</v-icon>
                                        </template>
                                        <span>Ver detalhes</span>
                                    </v-tooltip>
                                    <v-tooltip v-if="item.status === 0 || item.status === 1" bottom>
                                        <template #activator="{ on }">
                                            <v-icon v-on="on" size="20" class="mr-2" @click.stop="editItem(item)">mdi-pencil-outline</v-icon>
                                        </template>
                                        <span>Editar</span>
                                    </v-tooltip>
                                    <v-tooltip bottom>
                                        <template #activator="{ on }">
                                            <v-icon v-on="on" size="20" @click.stop="deleteItem(item)">mdi-delete-outline</v-icon>
                                        </template>
                                        <span>Excluir</span>
                                    </v-tooltip>
                                </div>
                            </template>
                        </v-data-table>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import axios from 'axios';

const STATUS = [
    { id: 0, name: 'Aberta', color: 'primary' },
    { id: 1, name: 'Fechada', color: 'primary' },
    { id: 5, name: 'Em andamento', color: 'success' },
    { id: 3, name: 'Suspensa', color: 'warning' },
    { id: 2, name: 'Interrompida', color: 'error' },
    { id: 4, name: 'Finalizada', color: 'grey' },
];

export default {
    name: "GeneralMeetingList",

    data: () => ({
        loading: false,
        items: [],
        count: 0,
        clients: [],
        statusOptions: STATUS,
        periods: [
            { text: 'Todas', value: '' },
            { text: 'Próximas', value: 'next' },
            { text: 'Anteriores', value: 'previous' },
        ],
        filter: { name: '', client_id: null, period: '', status: null },
        headers: [
            { text: 'Data', value: 'date', width: 120 },
            { text: 'Assembleia', value: 'name' },
            { text: 'Caso', value: 'client.name' },
            { text: 'Situação', value: 'status' },
            { text: '', value: 'actions', sortable: false, align: 'end' },
        ],
        options: { page: 1, itemsPerPage: 10 },
        footerOptions: {
            itemsPerPageText: 'Itens por página:',
            itemsPerPageOptions: [10, 20, 30, 40, 50],
            pageText: '{0}-{1} de {2}',
        },
    }),

    computed: {
        breadcrumbItems() {
            return [
                { text: 'Início', to: '/home', exact: true },
                { text: 'Assembleias', disabled: true },
            ];
        },
    },

    watch: {
        options: {
            handler() { this.load(); },
            deep: true,
        },
    },

    created() {
        this.loadClients();
    },

    methods: {
        statusName(status) {
            const found = STATUS.find((item) => item.id === status);
            return found ? found.name : '—';
        },

        statusColor(status) {
            const found = STATUS.find((item) => item.id === status);
            return found ? found.color : 'grey';
        },

        async loadClients() {
            try {
                const result = await axios.get('/api/clients', { params: { page: 1, limit: 1000 } });
                this.clients = result.data.content.data;
            } catch (error) {
                this.clients = [];
            }
        },

        search() {
            if (this.options.page !== 1) this.options = { ...this.options, page: 1 };
            else this.load();
        },

        async load() {
            this.loading = true;

            try {
                const search = Object.fromEntries(Object.entries(this.filter).filter(([, value]) => value || value === 0));
                const result = await axios.get('/api/admin/general-meetings', {
                    params: { page: this.options.page, limit: this.options.itemsPerPage, search: JSON.stringify(search) },
                });

                this.items = result.data.content.data;
                this.count = result.data.content.paging.total;
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), { position: 'top-right', timeout: 5000 });
            } finally {
                this.loading = false;
            }
        },

        viewItem(item) {
            this.$router.push(`/agcs/${item.id}`);
        },

        editItem(item) {
            this.$router.push(`/agcs/${item.id}/editar`);
        },

        async deleteItem(item) {
            const confirmed = await this.$dialog.confirm({
                text: `Tem certeza que deseja excluir <strong>${item.name}</strong>?<br><br>Esta ação é irreversível.`,
                title: 'Excluir assembleia',
                actions: { false: 'Cancelar', true: 'Excluir' },
            });
            if (!confirmed) return;

            try {
                await axios.delete(`/api/admin/general-meetings/${item.id}`);
                this.$dialog.notify.info('Assembleia excluída com sucesso', { position: 'top-right', timeout: 2000 });
                this.load();
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), { position: 'top-right', timeout: 5000 });
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.agc-date {
    display: flex;
    flex-direction: column;
    line-height: 1.3;

    span {
        font-size: 12px;
        color: var(--v-muted-base);
    }
}
</style>
